import { Glyph, JugglingScreen } from "@motleyhand/design"
import { useGetProductsQuery } from "@/money/api"
import type { Cart } from "@/money/model"
import { invariant } from "@/utils"

type Props = {
  cart: Cart
}

export default function CheckoutSuccess({ cart }: Props) {
  const { data: products, isLoading: isProductsLoading } = useGetProductsQuery()

  const baseProduct = products?.find(
    ({ id, productType }) =>
      productType === "base" &&
      cart.items.some(({ productId }) => productId === id),
  )
  if (isProductsLoading) {
    return <JugglingScreen />
  }
  invariant(baseProduct)
  invariant("successMessage" in baseProduct)

  return (
    <div className="flex min-h-[calc(100vh-12rem)] items-center justify-center px-6">
      <div className="-mt-16 text-center">
        <Glyph variant="burst-toss" size={64} />
        <h1 className="font-title text-3xl tracking-tight">
          {baseProduct.successMessage}
        </h1>
        <p className="mt-3 text-sm text-muted-foreground">
          You’re on {baseProduct.name} now. Receipt is on its way to your inbox
        </p>
      </div>
    </div>
  )
}
